import store from '@store/store';
import { fetch } from '../utils';
import apiUtils from '../utils/apiUtils';
import { apiConstants } from '../utils/constants';

const timezoneOffset = new Date().getTimezoneOffset();
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function getApiCommonHeaders() {
    const apiPartner = null,
        ret = {};

    apiPartner === null || (ret[apiConstants.HEADERS.GST_PARTNER_API] = apiPartner);
    ret[apiConstants.HEADERS.GST_TIMEZONE_OFFSET] = timezoneOffset;
    ret[apiConstants.HEADERS.GST_TIMEZONE] = timezone;

    return ret;
}

// TODO: IMPORTANT when going in production this should be changed back to Authorization instead of Bearer-Authorization
export function getApiSecuredHeaders() {
    const token = store.state.oidcStore.access_token;

    const ret = {
        ...getApiCommonHeaders(),
        ...(token && { 'Bearer-Authorization': `bearer ${token}` }),
        ...(token &&
            process.env.NODE_ENV === 'development' && { Authorization: `bearer ${token}` }),
    };
    return ret;
}

export const fetchAPI = {
    getList: (url, params = {}, headers = getApiSecuredHeaders()) => {
        return fetch
            .get(url, { headers, params })
            .then(apiUtils.checkStatusList)
            .catch(apiUtils.checkError);
    },
    getListRaw: (url, params = {}, headers = getApiSecuredHeaders()) => {
        return fetch
            .get(url, { headers, params })
            .then(apiUtils.checkStatusListRaw)
            .catch(apiUtils.checkError);
    },
    get: (url, params, headers = getApiSecuredHeaders()) => {
        return fetch
            .get(url, { headers, params })
            .then(apiUtils.checkStatus)
            .catch(apiUtils.checkError);
    },
    postListResponse: (url, data, headers = getApiSecuredHeaders()) => {
        return fetch
            .post(url, data, { headers })
            .then(apiUtils.checkStatusList)
            .catch(apiUtils.checkError);
    },
    post: (url, data, headers = getApiSecuredHeaders()) => {
        return fetch
            .post(url, data, { headers })
            .then(apiUtils.checkStatus)
            .catch(apiUtils.checkError);
    },
    patch: (url, data, headers = getApiSecuredHeaders()) => {
        return fetch
            .patch(url, data, { headers })
            .then(apiUtils.checkStatus)
            .catch(apiUtils.checkError);
    },
    put: (url, data, headers = getApiSecuredHeaders()) => {
        return fetch
            .put(url, data, { headers })
            .then(apiUtils.checkStatus)
            .catch(apiUtils.checkError);
    },
    putListResponse: (url, data, headers = getApiSecuredHeaders()) => {
        return fetch
            .put(url, data, { headers })
            .then(apiUtils.checkStatusList)
            .catch(apiUtils.checkError);
    },
    delete: (url, headers = getApiSecuredHeaders()) => {
        return fetch.delete(url, { headers }).then(apiUtils.checkStatus).catch(apiUtils.checkError);
    },
    request: (url, cfg) => {
        return fetch.request(url, cfg);
    },
};
